import { QFlex, QResourceIcon, QText, QTooltip, SearchResource } from '@qualio/ui-components';

const ItemWithCodeAndNameLabel = ({
  itemName,
  itemId,
  domain,
}: {
  itemName: string;
  itemId: string;
  domain?: SearchResource;
}) => {
  const label = (
    <QText as="span" fontSize="sm" title={itemName ? `${itemId} ${itemName}` : itemId}>
      <QText as="span" color="blue.500" fontWeight="semibold">
        {itemId}
      </QText>
      {itemName ? ` ${itemName}` : ''}
    </QText>
  );

  if (!domain) {
    return label;
  }

  return (
    <QFlex as="span" display="inline-flex" align="center" gap={2} minW={0}>
      <QResourceIcon domain={domain} />
      {label}
    </QFlex>
  );
};

export const CodeWithNameTooltip = ({
  code,
  name,
  domain,
}: {
  code: string;
  name?: string;
  domain?: SearchResource;
}) => {
  const chip = domain ? (
    <QFlex as="span" display="inline-flex" align="center" gap={1}>
      <QResourceIcon domain={domain} />
      <QText as="span">{code}</QText>
    </QFlex>
  ) : (
    <QText as="span">{code}</QText>
  );
  return name ? <QTooltip label={name}>{chip}</QTooltip> : chip;
};

export default ItemWithCodeAndNameLabel;
